export default "__VITE_ASSET__63bac13c__"